module.exports = __webpack_public_path__ + "static/media/AVISO IMPORTANTE_ONInternet2022.e6bc3f6e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/AVISO IMPORTANTE_ONInternet2022.pdf
// module id = 965
// module chunks = 0